import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_on_site_childcare_facilities_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_on_site_childcare_facilities_line_legal_requirements',
  name: 'Are on-site childcare facilities in line with legal requirements?',
  description:
    'This includes the provision of on-site childcare facilities, the location and the capacity limits according to size of the childcare facility.',
  meta: {
    slcpMeta: {
      key: 'hs-57--2',
      number: 'HS-CHI-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-57--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29410,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
